export const partnerSkinEnums = {
  pg: 0,
  topc: 1,
};
